import React, {useEffect, useState} from 'react';
import axios from "../axios";
import {
    Container,
    CreateBtn,
    DetailsBtns,
    DetailsHeading, Flex,
    H1,
    ListHeading, SmallSpacing,
    smallSpacing,
    Table,
    Td,
    Th,
    Tr
} from "../../styles";
import {Link} from "react-router-dom";
import useAdminStatus from "../hooks/useAdminStatus";

const Courses = () => {
    const [courses, setCourses] = useState([]);
    const { isAdmin } = useAdminStatus();

    useEffect(() => {
        axios.get('/courses/')
            .then(response => {
                setCourses(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this course?")) {
            axios.delete(`/courses/delete/${id}/`)
                .then(() => {
                    setCourses(courses.filter(course => course.id !== id));
                })
                .catch(error => {
                    console.error("There was an error deleting the course!", error);
                });
        }
    }
      if (!courses) {
        return <div>Loading...</div>;
    }
    return (
        <Container>
            <ListHeading>
                <H1>Course List</H1>
                {isAdmin && (
                <Link to="/courses/create">
                    <CreateBtn>
                        Add Course
                    </CreateBtn>
                </Link>)}
            </ListHeading>
            <Table>
                <Tr>
                    <Th>Course Code</Th>
                    <Th>Course Name</Th>
                    <DetailsHeading>Details</DetailsHeading>
                </Tr>
                {courses.map((course) => (
                    <Tr key={course.id}>
                        <Td>{course.code}</Td>
                        <Td>{course.name}</Td>
                            <DetailsBtns>
                                <Flex>
                                <Link to={`/course/${course.id}`}>View</Link>
                                    {isAdmin && (<>
                                <SmallSpacing/>
                                <Link to={`/courses/update/${course.id}`}>Update</Link>
                                <SmallSpacing/>
                                <Link to="#" onClick={() => handleDelete(course.id)}>Delete</Link>
                           </>)}
                            </Flex>
                                </DetailsBtns>
                    </Tr>
                ))}
            </Table>

        </Container>
    );
};

export default Courses;